@if (isValidRange) {
  <div
    class="player-cut-marker"
    [style.left.%]="relativePosLeft"
    [style.width.%]="relativeWidth"
  ></div>
}
